import {useEffect, useState} from 'react';

const SPIDER_URL = process.env.REACT_APP_SPIDER_URL;


const UseSpiderSse = (hash) => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        if (!hash) return;

        const source = new EventSource(`${SPIDER_URL}/sse/subscribe/${hash}`,{heartbeatTimeout: 1});

        source.onmessage = event => {
            const events = JSON.parse(event.data);

            if (events.type !== 'heartbeat') {
                setEvents(events.value);
            }
        }

        source.onerror = e => {
            console.error('Error to load events.');
            console.error(e);
        };

        source.onclose = e => console.error(e);

        return () => source.close();

    }, [hash]);

    return {events}
};

export default UseSpiderSse;